<!-- 查看部门详情 -->
<template>
    <!--添加界面-->
      <el-dialog class="model-depart-form-view" width="850px" title="部门详情" :visible="myVisible"  :destroy-on-close="true" @close="handerClose"
        :close-on-click-modal="false">
        <el-row  class="toolbar" style="margin-bottom: -10px;" v-loading="listLoading" >
          <el-form label-width="100px" label-position="left"  ref="ruleForm" v-if="departDetail">
            <el-col :span="12">
                <el-form-item label="部门名称："> {{ departDetail.deptname || '-' }} </el-form-item>
            </el-col>  

            <el-col :span="12">
               <el-form-item label="部门管理员：">{{ departDetail.deptManagerName || '-' }} </el-form-item>
            </el-col>  
            
            <el-col :span="24">
              <h4 class="title">部门人员({{ departDetail.userList.length }})</h4>
                <!--用户列表-->
                <el-table  :data="departDetail.userList" highlight-current-row   style="width: 100%;"    :height="500"   ref="companyRef"   >
                  <!-- <el-table-column type="selection" width="50"></el-table-column> -->
                  <el-table-column prop="phone" label="账号" width="130" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="name" label="姓名"  width="100" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="typeName" label="软件类型"  width="140" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="deptname" label="部门" min-width="160" show-overflow-tooltip>
                  </el-table-column>
                </el-table>
            </el-col>    
            
          </el-form>
        </el-row>
      </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { API_userCom } from '@/api/index.js'
import  utils  from '@/utils/index'
export default {
  props: {
    mode: {
      type: String,
      default: 'save'
    },

    visible: {
      type: Boolean,
      default: false
    },

    processDetail: {
      type: Object,
      default: () => null
    }
  },
  data () {
   
    return {
      myVisible: false,
      listLoading: false,
      
      token:'',
      checkCode:'',

      departDetail: null
    };
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },

  created() {
    this.myVisible = this.visible
    let { token, checkCode } = utils.getParamsByCookie();
    this.token = token;
    this.checkCode = checkCode;
    this.getDetail();
  },

  methods: {

    getDetail() {
      let param = {
          token: this.token,
          checkCode: this.checkCode,
          companyid: this.$route.query.companyId,
          id: this.processDetail.id
      }
       this.listLoading = true;
       API_userCom.getDepartDetail(param).then((res) =>{
        if(res.data.code == 200){
          let data = res.data.data;
          this.departDetail = data;
        }else {
           if(res.data.code == 403){
                this.$router.push({path: 'loginAdmin'});
            }
        }
       this.listLoading = false;
      }).catch(err =>{
        this.listLoading = false;
        this.$message.error('数据丢失，试试重新登录1！');
      });
    },

    handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false)
    },
   
  }
}

</script>
<style lang='scss'>

.model-depart-form-view {
  .el-dialog__body {
    min-height: 30vh;
    padding: 20px 30px;
  }
  .title {
    margin-bottom: 10px 0 20px 0;
    font-size: 14px;
    color: #666;
    font-weight: normal;
  }
  
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// ModalFormView.vue?4fd9d7a5